import React, { useState } from 'react';
import { connect } from 'react-redux';
import { __ } from '../../../core/utils';

import styles from '../../../styles/containers/Lightbox.scss';

import { hideLightbox } from '../../../redux/actions/general/lightbox';

import Tooltip from '../../../components/Tooltip';
import OutsideClickWrapper from '../../../components/OutsideClickWrapper';
import { OSDTools } from '../../../components/CanvasEditor/components/Toolbar/OSDTools';

import { useExportCanvasAnnotations } from './../hooks/useExportCanvasAnnotations';

import CloseSmallIcon from '../../../assets/images/close-small-40x40.svg';
import DownloadIcon from '../../../assets/images/download-15x15.svg';

const CanvasWrapperHeader = ({
  image,
  canvas_editor: {
    viewer: editorViewer,
    fabricOverlay: editorFabricOverlay,
  },
  imageWithSize,
  viewer: lightboxViewer,
  fabricOverlay: lightboxFabricOverlay,
  disabled,
}) => {
  const [openedDownloadOptions, setOpenedDownloadOptions] = useState(false);
  const viewer = disabled ? lightboxViewer : lightboxViewer || editorViewer;
  const fabricOverlay = disabled
    ? lightboxFabricOverlay
    : lightboxFabricOverlay || editorFabricOverlay;

  const { exportWithCanvasAnnotations } = useExportCanvasAnnotations({
    image,
    imageWithSize,
    fabricOverlay,
  });

  return (
    <div className={styles.toolbar}>
      <Tooltip text={image.title}>
        <div className={styles.title}>{image.title}</div>
      </Tooltip>
      <div className={styles.rightControls}>
        <div className={styles.osdTools}>
          <OSDTools viewer={viewer} />
        </div>

        {image.download_url && (
          <>
            <div className={styles.separator} />

            <DownloadIcon
              className={styles.downloadIcon}
              onClick={() => setOpenedDownloadOptions(true)}
            />
          </>
        )}

        <div className={styles.separator} />

        {openedDownloadOptions && (
          <OutsideClickWrapper
            onClickOutside={(e) => {
              e.stopPropagation();

              setOpenedDownloadOptions(false);
            }}
          >
            <div className={styles.downloadOptions}>
              {image.stream_url && (
                <span
                  onClick={() => {
                    window.open(image.download_url, '_blank');
                    setOpenedDownloadOptions(false);
                  }}
                >
                  {__('files.lightbox.download.original-file')}
                </span>
              )}
              <span
                onClick={() => {
                  exportWithCanvasAnnotations();

                  setOpenedDownloadOptions(false);
                }}
              >
                {__('files.lightbox.download.original-file-with-annotations')}
              </span>
            </div>
          </OutsideClickWrapper>
        )}

        <CloseSmallIcon onClick={hideLightbox} className={styles.close} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  canvas_editor: state.canvas_editor,
});

const mapDispatchToProps = {
  hideLightbox,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CanvasWrapperHeader);
